<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i>
                    <span class="card-label fs-3 ms-1">Quản lý vùng trồng</span>
                </h3>
            </div>
            <div class="card-body">
                <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="150px"
                    class=" d-flex flex-column">
                    <el-form-item label="Tiêu đề" prop="cTieuDe">
                        <el-input v-model="formData.cTieuDe"></el-input>
                    </el-form-item>
                    <el-form-item label="Hình ảnh" prop="iconFile">
                        <el-upload action="#" list-type="picture-card" :auto-upload="false" placeholder="Chọn hình ảnh"
                            :on-preview="handlePictureCardPreview" ref="upload" :file-list="iconFile"
                            :on-change="handleChangeFile" :on-remove="handleRemoveFile" accept="image/*">
                            <div class="d-flex align-items-center justify-content-center w-100 h-100">
                                <i class="el-icon-plus" v-if="iconFile.length == 0"></i>
                                <i class="el-icon-refresh" v-if="iconFile.length > 0"></i>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="Nội dung" prop="cNoiDung">
                        <div class="w-100">
                            <QuillEditor class="w-100 d-flex flex-column" ref="quillEditor" @text-change="onTextChange"
                                :options="quillOptions" />
                        </div>
                    </el-form-item>
                </el-form>
                <div class="w-100 d-flex justify-content-end align-items-center">
                    <el-button type="warning" plain @click="handleResetForm">
                        <i class="el-icon-refresh-left" />Đặt lại</el-button>
                    <el-button type="success" @click="handleSaveForm" plain>
                        <i class="el-icon-check" />Lưu</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Plantations } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import ImageResize from "quill-image-resize";
import { baseUrl } from "@/utils/global";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";
import { defineComponent } from "vue";

Quill.register("modules/imageResize", ImageResize);
export default defineComponent({
    name: 'Plantations',
    components: {
        QuillEditor
    },
    data() {
        return {
            store: useStore(),
            iconFile: [],
            dialogImageUrl: null,
            dialogVisible: false,
            formData: {
                iconFile: [],
                cTieuDe: "",
                cNoiDung: ""
            },
            rules: {
                iconFile: {
                    required: true, message: 'Xin vui lòng chọn bản ghi', trigger: 'change', validator: (rule, value, callback) => {
                        if (this.iconFile.length === 0) {
                            callback(new Error('Xin vui lòng chọn bản ghi'));
                        } else {
                            callback();
                        }
                    }
                },
                cTieuDe: [{ required: true, message: "Xin vui lòng nhập tiêu đề.", trigger: "blur" }],
                cNoiDung: [{ required: true, message: "Xin vui lòng nhập nội dung.", trigger: "blur" }],
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ 'color': [] }, { 'background': [] }],
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ indent: "-1" }, { indent: "+1" }],
                ["image", "link"], ["clean"]
            ],
            editorSettings: {
                modules: {
                    imageResize: {}
                }
            },
            quillOptions: {
                theme: 'snow',
                modules: {
                    imageResize: {},
                    toolbar: {
                        container: [
                            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            ["image", "link"], ["clean"],
                        ],
                        handlers: {
                            image: this.customImageHandler
                        }
                    }
                }
            },
        }
    },
    methods: {
        handleGetData() {
            this.store.dispatch(Plantations.showPlantations).then(res => {
                if (res.code == 200) {
                    if (res.data[0]) {
                        this.formData = res.data[0]
                        this.$refs.quillEditor.setHTML(this.formData.cNoiDung)
                        this.iconFile = []
                        if (res.data[0].cHinhAnhUrl) {
                            this.addImageFromURL(baseUrl + res.data[0].cHinhAnhUrl)
                        }
                    }
                }
            })
        },
        addImageFromURL(url) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "image.jpg", { type: blob.type });
                    this.iconFile.push({
                        name: file.name,
                        url: URL.createObjectURL(file),
                        status: 'success',
                        uid: Date.now(),
                        raw: file
                    });
                });
        },
        handlePictureCardPreview(val) {
            this.dialogImageUrl = val.url
            this.dialogVisible = true
        },
        async handleChangeFile(file, iconFile) {
            this.iconFile = [file]
            this.formData.iconFile = this.iconFile
        },
        handleRemoveFile(file, iconFile) {
            this.iconFile = []
            this.formData.iconFile = this.iconFile
        },
        handleResetForm() {
            this.handleGetData()
        },
        handleSaveForm() {
            this.$refs.formDataRef.validate((valid) => {
                if (valid) {
                    this.$confirm("Bạn có muốn lưu vùng trồng không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    }).then(() => {
                        const formData = new FormData()
                        if (this.iconFile.length > 0) {
                            if (this.iconFile[0].status == "ready") {
                                formData.append('image', this.iconFile[0].raw)
                            }
                        }
                        formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
                        if (this.formData.id) {
                            this.store.dispatch(Plantations.updatePlantations, formData).then(res => {
                                if (res.code == 200) {
                                    this.handleGetData()
                                    ElMessage({ message: "Cập nhật vùng trồng thành công", type: "success" })
                                } else {
                                    ElMessage({ message: "Cập nhật vùng trồng không thành công", type: "error" })
                                }
                            }).catch(() => {
                                ElMessage({ message: "Cập nhật vùng trồng không thành công", type: "error" })
                            })
                        } else {
                            this.store.dispatch(Plantations.savePlantations, formData).then(res => {
                                console.log("test1")
                                if (res.code == 200) {
                                    this.handleGetData()
                                    ElMessage({ message: "Thêm vùng trồng mới  thành công", type: "success" })
                                } else {
                                    console.log("test5")
                                    ElMessage({ message: "Thêm vùng trồng mới không thành công", type: "error" })
                                }
                            }).catch(() => {
                                console.log("test6")
                                ElMessage({ message: "Thêm vùng trồng mới không thành công", type: "error" })
                            })
                        }
                    }).catch(() => {

                    })
                }
            })
        },

        customImageHandler() {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/*')
            input.click()

            input.onchange = () => {
                const file = input.files[0]
                const reader = new FileReader()

                reader.onload = (e) => {
                    const quill = this.$refs.quillEditor.getQuill()
                    const range = quill.getSelection()
                    const formData = new FormData()
                    formData.append("image", file);
                    this.store.dispatch(Plantations.uploadPlantationsArticleImage, formData).then(res => {
                        if (res.code == 200) {
                            const url = baseUrl + res.msg
                            quill.insertEmbed(range.index, "image", url);
                        } else {
                            ElMessage({ message: "Thêm hình ảnh không thành công", type: "error" })
                        }
                    }).catch(() => {
                        ElMessage({ message: "Thêm hình ảnh không thành công", type: "error" })
                    })
                }

                reader.readAsDataURL(file)
            }
        },
        onTextChange(val) {
            this.formData.cNoiDung = this.$refs.quillEditor.getHTML()
        },
    },
    mounted() {
        this.handleGetData()
    }
})
</script>